import assets from "app/assets";
import gsap from "gsap";
import { Container, DEG_TO_RAD, Graphics, ParticleContainer, Sprite } from "pixi.js";
export default class Stars extends Container {
  constructor(nbr, boxarea, repeat = 1) {
    super();
    this.animate = this.animate.bind(this);
    this.show = this.show.bind(this);
    this.debugRect = new Graphics();
    this.debugRect.beginFill(0x0000ff, .2);
    this.debugRect.drawRect(-boxarea.w >> 1, -boxarea.h >> 1, boxarea.w, boxarea.h);
    this.debugRect.endFill();
    this.debugRect.visible = false;
    this.addChild(this.debugRect);
    this.particules = new ParticleContainer(nbr, {
      scale: true,
      position: true,
      rotation: true,
      uvs: true,
      alpha: true
    });
    this.addChild(this.particules);
    this.particules.x = -boxarea.w >> 1;
    this.particules.y = -boxarea.h >> 1;
    this._boxarea = boxarea;
    this._stars = [];
    this._scaleMax = .3;
    this._loop = false;
    this._ready = true;
    this._readyCpt = nbr;
    this._repeat = repeat;
    for (let i = 0; i < nbr; i++) {
      const star = new Sprite(assets.textures.star.texture);
      star.anchor.set(.5);
      star.scale.set(0);
      star.x = Math.random() * this._boxarea.w;
      star.y = Math.random() * this._boxarea.h;
      star.rotation = Math.random() * 90 * DEG_TO_RAD;
      this.particules.addChild(star);
      this._stars.push(star);
    }
    this.visible = false;
  }
  show() {
    if (!this._ready) {
      return;
    }
    this._ready = false;
    for (let i = 0; i < this._stars.length; i++) {
      this.animate(this._stars[i]);
    }
    this._readyCpt = 0;
    this.visible = true;

    // this._loop = true;

    // setTimeout(() => {
    //     this._loop = false;
    // }, this._repeat * 1000);
  }
  hide() {
    this._animationTween && this._animationTween.kill();
    this.visible = false;
  }
  animate(s) {
    s.scale.set(0);
    s.rotation = Math.random() * 90 * DEG_TO_RAD;
    this._animationTween = gsap.to(s.scale, {
      delay: Math.random(),
      duration: .3,
      x: this._scaleMax,
      y: this._scaleMax,
      repeat: 1,
      yoyo: true,
      yoyoEase: "none",
      onComplete: () => {
        this._readyCpt++;
        if (this._readyCpt >= this._stars.length) {
          this._ready = true;
          !this._loop && (this.visible = false);
        }
        this._loop && this.animate(s);
      }
    });
  }
  set loop(val) {
    this._loop = val;
  }
  set debug(val) {
    this.debugRect.visible = val;
  }
  set scaleMax(val) {
    this._scaleMax = val;
  }
}
